import React, { useState } from "react";
import { downloadTgz } from "../utils/functions";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  InputAdornment,
  DialogActions,
  Button,
} from "@material-ui/core";

import { makePostTarballDownload } from "../backend/zip";
import { stateToFile } from "../utils/functions";

export default ({ close, isDownloadTgzOpen }) => {
  const [fileName, setFileName] = useState("features");

  const gzipFile = async () => {
    try {
      const fileData = stateToFile();
      return await makePostTarballDownload(fileName, fileData);
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <Dialog open={isDownloadTgzOpen} onClose={close}>
      <DialogTitle id="form-dialog-title">Download TGZ</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          id="name"
          label="File Name"
          value={fileName}
          onChange={(e) => setFileName(e.target.value)}
          InputProps={{
            endAdornment: (
              <InputAdornment position="start">.tgz</InputAdornment>
            ),
          }}
          fullWidth
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={close} color="primary">
          Cancel
        </Button>
        <Button
          onClick={() => {
            downloadTgz(fileName, gzipFile());
            close();
          }}
          color="primary"
        >
          Download
        </Button>
      </DialogActions>
    </Dialog>
  );
};
